import { css } from 'styled-components';
import { COLORS } from '../../design/tokens';

const onError = ({ error }) =>
  error
    ? css`
        & .ant-select-selection.ant-select-selection--single {
          border-color: ${COLORS.SELECT.ERROR.BORDER};
          color: ${COLORS.SELECT.ERROR.TEXT};
          box-shadow: none;
          background-color: ${COLORS.SELECT.ERROR.BACKGROUND};
        }
      `
    : '';

const styles = {
  container: css`
    padding-top: 8px;
    padding-bottom: 8px;
  `,

  label: css`
    text-transform: uppercase;
    letter-spacing: 0.6px;
    line-height: 22px;
    font-weight: 600;
    font-size: 14px;
  `,

  iconContainer: css`
    svg {
      position: relative;
      top: 3px;
      margin-right: 5px;
    }
  `,

  select: css`
    width: 100%;
    min-width: 150px;
    border-radius: 0;
    border-color: ${COLORS.SELECT.BASE.BORDER};
    background-color: ${COLORS.SELECT.BASE.BACKGROUND};
    padding-top: 8px;
    margin-top: 4px !important;
    margin-bottom: 8px !important;

    &.ant-select-open .ant-select-selection {
        border-width: 2px !important;
        border-color: ${COLORS.SELECT.ACTIVE.BORDER};
     }

    &.ant-select-lg {
      padding-top: 0;
      .ant-select-selection__rendered {
        line-height: 29px;
      }
    }

    & .ant-select-selection,
    .ant-select-selection__rendered,
    .ant-select-selection-selected-value {
      width: 100%;
      color: ${COLORS.SELECT.SELECTED.TEXT}
      font-size: 16px;
      padding-top: 1.2px;
      border-radius: 0;
      border-width: 2px !important;
      border-color: ${COLORS.SELECT.BASE.BORDER};
    }



    & .ant-select-selection:hover,
     .ant-select-selection:focus {
      border-color: ${COLORS.SELECT.HOVER.BORDER} !important;
      border-width: 2px !important;

    }


    & .ant-select-selection:focus {
    box-shadow: 0 0 0 2px rgb(70 103 237 / 0.2);
    }
   .ant-select-search--inline {
      line-height: 24px;
      height: 22px;
      width: 83%;
    }
    &.country-selector {
      position: relative;
      transition: all 100ms ease-out;

      .ant-select-selection {
        height: 40px;
        border-right-width: 0 !important;
        svg {
          position: relative;
          top: 0;
          margin: 0;
        }
      }

      &:focus, &:focus-within {
          width: 120px !important;
          min-width: 120px !important;
      }

      .ant-select-selection {
        background-color: #F8F9FA;
        border-width: 2px !important;
      }

      .ant-select-selection-selected-value {
        height: 22px;
        width: 22px;
        padding: 1px 0 0;
        top: 3px;
        position: relative;
      }
    }

    &:active input {
      border-color: ${COLORS.SELECT.ACTIVE.BORDER} !important;
      border-width: 2px !important;
    }

    ${onError}
  `,
  message: css`
    color: ${props => (props.error ? COLORS.TEXT.ERROR : COLORS.TEXT.BLACK)};
    margin-top: 6px;
  `
};

export default styles;
